module.exports = __webpack_public_path__ + "static/media/logo--light.17cea9e3.svg";